<div
    class="chart-notification-container"
    *ngIf="!selected && isToggleActive && !comingSoon"
>
    <p>
      To view the {{ chartName }} chart, click a cell on the map
    </p>
</div>

<div
    class="chart-notification-container"
    *ngIf="selected && isToggleActive && !containsInfo && !comingSoon && (!selectedYear || noAccessibleYears)"
>
    <p>This area doesn't have enough data to generate a chart.</p>
</div>

<div
  class="chart-notification-container"
  *ngIf="selected && isToggleActive && !containsInfo && !comingSoon && selectedYear && !noAccessibleYears"
>
  <p>Not enough data for {{selectedYear}} to generate this chart. Try another year.</p>
</div>

<div class="chart-notification-container" *ngIf="comingSoon && isToggleActive">
    <p>{{ customText }}</p>
</div>
